import { render } from "./Code.vue?vue&type=template&id=261f6910&scoped=true"
import script from "./Code.vue?vue&type=script&lang=js"
export * from "./Code.vue?vue&type=script&lang=js"

import "./Code.vue?vue&type=style&index=0&id=261f6910&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-261f6910"

export default script